<!--
 * @Author: zzz
 * @Date: 2021-02-06 22:10:33
 * @LastEditTime: 2021-02-22 17:03:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \04eos-app\src\pages\testDrive\day\index.vue
-->
<template>
  <div id="Month"></div>
</template>
<script>
/* eslint-disable */
import Calendar from 'tui-calendar'
import dayjs from 'dayjs'
import { Theme, StateColors } from './config'
import 'tui-calendar/dist/tui-calendar.min.css'
export default {
  name: 'CalendarMonth',
  props: {
    schedules: {
      type: Array,
      require: true
    },
    start: {
      type: String,
      require: true
    },
    storeCode: {
      type: String
    }
  },
  watch: {
    'schedules': {
      handler () {
        this.calendarData = JSON.parse(JSON.stringify(this.schedules))
        // 增加日程
        this.schedulePush(this.calendarData)
      },
      immediately: true,
      deep: true
    },
    'start': {
      handler () {
        window.month.setDate(`${this.start} 00:00:00`)
        window.month.render()
      },
      immediately: true,
      deep: true
    }
  },
  data () {
    return {
      month: {},
      calendarData: []
    }
  },
  methods: {
    // 渲染日历
    calendarInit () {
      return new Calendar('#Month', {
        id: 'calendarMonth',
        defaultView: 'month',
        scheduleView: false,
        isReadOnly: true,
        // useDetailPopup: false,
        theme: Theme,
        template: {
          task: function (schedule) {
            return '&nbsp;&nbsp;#' + schedule.title;
          }
        },
        month: {
          visibleScheduleCount: 10,
          showTimezoneCollapseButton: true,
          timezonesCollapsed: false,
          daynames: ['日', '一', '二', '三', '四', '五', '六'],
          timegridCurrentTime: false,
          startDayOfWeek: 0, // 一周开始的时间
          narrowWeekend: false, // 使周末栏变窄（1/2宽度）
          workweek: false, // 仅显示5天
          //   showTimezoneCollapseButton: true,
          //   timezonesCollapsed: true,
          hourStart: 8,
          hourEnd: 21
        }
      }
      )
    },
    // 数据整理
    dataFormat (calendarData) {
      /*
        同一时段 && 同意状态的
      */
      // 空数组
      let tempArr = []
      // 按开始时段过滤
      const startTime = {}
      // 过滤时段-开始时间一致
      calendarData.forEach(e => {
        // 同一日期对比
        if (!(e.date in startTime)) {
          startTime[e.date] = []
        }
        // 同一预约开始时段
        startTime[e.date].push(e)
      })
      Object.values(startTime).forEach(values => {
        values[0].title = values.length
        values[0].category = 'time'
        tempArr.push(values[0])
      })
      return tempArr
    },
    // 添加日程
    schedulePush (calendarData) {

      // 根据状态设置日历颜色
      // this.calendarData.forEach(e => {
      //   window.month.setCalendarColor(e.calendarId, {
      //     color: '#FFF',
      //     // bgColor: StateColors[`${e.state}`],
      //     bgColor: '#B4B4B4',
      //     borderColor: StateColors[`${e.state}`],
      //     dragBgColor: '#FFF'
      //   })
      // })
      const formated = this.dataFormat(calendarData)
      window.month.clear();
      window.month.createSchedules(formated)
      window.month.on("clickSchedule", (item) => {
        const day = dayjs(item.schedule.start).format('YYYY-MM-DD')
        this.$router.push({
          path: '/testDriveList',
          query: {
            'storeCode': this.storeCode,
            'startTime': day,
            'endTime': day
          }
        })
      });
    }
  },
  mounted () {
    window.month = this.calendarInit()
  }
}
</script>
<style lang="less">
@import "./index.less";
</style>